'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizePropTypes = exports.sizeProps = exports.isValidSize = exports.colorPropTypes = exports.colorProps = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // color


var colorProps = exports.colorProps = function colorProps(props) {
  return {
    black: props.black,
    blue: props.blue,
    darkGray: props.darkGray,
    darkerGray: props.darkerGray,
    darkestGray: props.darkestGray,
    gray: props.gray,
    green: props.green,
    lightGray: props.lightGray,
    lighterGray: props.lighterGray,
    lightestGray: props.lightestGray,
    orange: props.orange,
    pink: props.pink,
    purple: props.purple,
    red: props.red,
    white: props.white,
    yellow: props.yellow
  };
};

var colorPropTypes = exports.colorPropTypes = {
  black: _propTypes2.default.bool,
  blue: _propTypes2.default.bool,
  darkGray: _propTypes2.default.bool,
  darkerGray: _propTypes2.default.bool,
  darkestGray: _propTypes2.default.bool,
  gray: _propTypes2.default.bool,
  green: _propTypes2.default.bool,
  lightGray: _propTypes2.default.bool,
  lighterGray: _propTypes2.default.bool,
  lightestGray: _propTypes2.default.bool,
  orange: _propTypes2.default.bool,
  pink: _propTypes2.default.bool,
  purple: _propTypes2.default.bool,
  red: _propTypes2.default.bool,
  white: _propTypes2.default.bool,
  yellow: _propTypes2.default.bool // size

};

var isValidSize = exports.isValidSize = _propTypes2.default.oneOf(['large', 'larger', 'largest', 'medium', 'small', 'smaller', 'smallest']);

var sizeProps = exports.sizeProps = function sizeProps(props) {
  return {
    large: props.large,
    larger: props.larger,
    largest: props.largest,
    small: props.small,
    smaller: props.smaller,
    smallest: props.smallest
  };
};

var sizePropTypes = exports.sizePropTypes = {
  large: _propTypes2.default.bool,
  larger: _propTypes2.default.bool,
  largest: _propTypes2.default.bool,
  small: _propTypes2.default.bool,
  smaller: _propTypes2.default.bool,
  smallest: _propTypes2.default.bool
};